export const detailConfigs = {
  zhizuo: [
    {
      name: 'time',
      label: '时间',
    },
    {
      name: 'cl',
      label: '作业产量',
      slot: true,
    },
    {
      name: 'xl',
      label: '制作效率',
      slot: true,
    },
    {
      name: 'zl',
      label: '验收一次缺陷率',
      width: 150,
      slot: true,
    },
    {
      name: 'hs',
      label: '作业有效时长',
      width: 140,
      slot: true,
    },
    {
      name: 'cl_dbb',
      label: '产量达标比',
      width: 100,
      slot: true,
    },
    {
      name: 'xl_dbb',
      label: '效率达标比',
      width: 100,
      slot: true,
    },
    {
      name: 'zl_dbb',
      label: '质量达标比',
      width: 100,
      slot: true,
    },
    {
      name: 'hs_dbb',
      label: '有效时长比',
      slot: true,
      width: 100,
    },
    {
      name: 'total_score',
      label: '综合得分',
      fixed: 'right',
    },
  ],
  neijian: [
    {
      name: 'time',
      label: '时间',
    },
    {
      name: 'cl',
      label: '内检产量',
    },
    {
      name: 'xl',
      label: '内检效率',
      slot: true,
    },
    {
      name: 'zl',
      label: '内检人员缺陷率',
      slot: true,
      width: 150,
    },
    {
      name: 'hs',
      label: '内检有效时长',
      width: 140,
      slot: true,
    },
    {
      name: 'cl_dbb',
      label: '产量达标比',
      width: 100,
      slot: true,
    },
    {
      name: 'xl_dbb',
      label: '效率达标比',
      width: 100,
      slot: true,
    },
    {
      name: 'zl_dbb',
      label: '质量达标比',
      width: 100,
      slot: true,
    },
    {
      name: 'hs_dbb',
      label: '有效时长比',
      width: 100,
      slot: true,
    },
    {
      name: 'total_score',
      label: '综合得分',
      fixed: 'right',
    },
  ],
};

export const radarExtend = {
  title: {
    show: true,
    text: '综合得分 --',
    left: 'center',
  },
  legend: {
    top: 34,
    itemWidth: 14,
    itemHeight: 14,
  },
  radar: {
    shape: 'polygon',
    center: ['50%', '57%'],
    radius: ['25%', '60%'],
    indicator: [
      {
        name: '质量',
        id: 'zl_weight',
      },
      {
        name: '效率',
        id: 'xl_weight',
      },
      {
        name: '产量',
        id: 'cl_weight',
      },
      {
        name: '有效时长',
        id: 'hs_weight',
      },
    ],
    axisLine: {
      show: false,
    },
    splitNumber: 4,
    splitArea: {
      areaStyle: {
        color: ['#FFF'],
      },
    },
    splitLine: {
      lineStyle: {
        type: 'dashed',
      },
    },
  },
  color: ['#334FC5', '#FA7962'],
  series: {
    name: 'radar',
    type: 'radar',
    lineStyle: {
      color: '#4D5EAA',
      width: 2,
    },
    tooltip: {
    },
  },
};
export const lineExtendRating = {
  color: ['#334FC5', '#FF7443'],
  series: {
    label: {
      normal: {
        show: true,
      },
    },
  },
  yAxis: {
    splitLine: {
      show: false,
    },
    axisTick: {
      show: true,
    },
    axisLine: {
      show: true,
    },
    position: 'left',
  },
  xAxis: {
    axisLine: {
      show: true,
    },
    axisTick: {
      show: true,
    },
  },
};
export const dimensionExtendCommond = Object.assign({}, lineExtendRating);
export const dimensionExtend = [
  Object.assign({}, dimensionExtendCommond, {
    tooltip: {
      formatter(params) {
        let str = '';
        params.forEach((item) => {
          // str += item.marker + item.seriesName + ' ' + item.value[1] + '%' + '<br/>'
          str += `${item.marker}${item.seriesName} ${item.value[1]}%<br/>`;
        });
        return str;
      },
    },
  }),
  Object.assign({}, dimensionExtendCommond, {
    tooltip: {
      formatter(params) {
        let str = '';
        params.forEach((item) => {
          // str += item.marker + item.seriesName + ' ' + item.value[1] + ' mark/人天' + '<br/>'
          str += `${item.marker}${item.seriesName} ${item.value[1]} mark/人天<br/>`;
        });
        return str;
      },
    },
  }),
  Object.assign({}, dimensionExtendCommond, {
    tooltip: {
      formatter(params) {
        let str = '';
        params.forEach((item) => {
          // str += item.marker + item.seriesName + ' ' + item.value[1] + ' 个mark' + '<br/>'
          str += `${item.marker}${item.seriesName} ${item.value[1]} 个mark<br/>`;
        });
        return str;
      },
    },
  }),
  Object.assign({}, dimensionExtendCommond, {
    tooltip: {
      formatter(params) {
        let str = '';
        params.forEach((item) => {
          // str += item.marker + item.seriesName + ' ' + item.value[1] + 'h/天' + '<br/>'
          str += `${item.marker}${item.seriesName} ${item.value[1]}h/天<br/>`;
        });
        return str;
      },
    },
  }),
];
export const dataZoom = [{
  type: 'inside',
  show: true,
  start: 0,
  end: 100,
}, {
  start: 0,
  end: 100,
  height: 20,
}];

export const dimensionSelect = {
  zhizuo: [
    {
      label: '验收一次缺陷率',
      value: '1',
    },
    {
      label: '制作效率',
      value: '2',
    },
    {
      label: '制作产量',
      value: '3',
    },
    {
      label: '有效时长',
      value: '4',
    },
  ],
  neijian: [
    {
      label: '内检人员缺陷率',
      value: '1',
    },
    {
      label: '内检效率',
      value: '2',
    },
    {
      label: '内检产量',
      value: '3',
    },
    {
      label: '有效时长',
      value: '4',
    },
  ],
};
export const overallRatingSelect = {
  zhizuo: [
    {
      label: '整体得分',
      value: '0',
    },
    {
      label: '验收一次缺陷率',
      value: '1',
    },
    {
      label: '制作效率',
      value: '2',
    },
    {
      label: '制作产量',
      value: '3',
    },
    {
      label: '有效时长',
      value: '4',
    },
  ],
  neijian: [
    {
      label: '内检人员缺陷率',
      value: '1',
    },
    {
      label: '内检效率',
      value: '2',
    },
    {
      label: '内检产量',
      value: '3',
    },
    {
      label: '有效时长',
      value: '4',
    },
  ],
};
export const rules = {
  production_line: [
    {
      required: true, message: '请选择产线',
    },
  ],
  time_type: [
    {
      required: true, message: '请选择周期',
    },
  ],
  operator: [
    {
      required: true, message: '请选择人员', trigger: 'focus',
    },
  ],
};
export const info = {
  operator: '--', // 人员
  operator_cn: '--', // 人员中文名
  outsourcer: '--', // 供应商
  production_line_rank: '--', // 产线内排名
  outsourcer_rank: '--', // 供应商内排名
  evaluation: '', // 评价
  advice: '', // 建议
  rank_detail: [],
};
